import COS from 'cos-js-sdk-v5'
const cos = new COS({
  SecretId: 'AKIDpr8UE16F2mQXN4axACC1qPuGRjrnYAbr',
  SecretKey: 'BA5qRq36yfYIuQo6HNMBrPo4A7xfEfzC'
})

const bucket = 'ytweb-1322500783'
const region = 'ap-shanghai'
const path = '/images_new/'

//公有上传
export const uploadFile = async (
  file: any,
  key: string
): Promise<{
  url: string
}> => {
  const fileMd5 = path + key

  return new Promise((resolve, reject) => {
    getCosUrlbykey(fileMd5)
      .then(url => {
        return resolve({
          url: url
        })
      })
      .catch(async () => {
        try {
          const res = await cos.uploadFile({
            Bucket: bucket,
            Region: region,
            Key: fileMd5, // 存储在桶里的对象键（例如:1.jpg，a/b/test.txt，图片.jpg）支持中文，必须字段
            Body: file // 上传文件对象
            // SliceSize: 1024 * 1024 * 5,     /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */
          })

          if (res?.statusCode === 200) {
            return resolve({
              // etag: res.ETag,
              url: location.protocol + '//' + res.Location
              // id: res.RequestId
            })
          }
        } catch (err: any) {
          const errorMsg = typeof err === 'object' ? err?.message : err

          console.error(errorMsg, { fileMd5, href: location.href })

          return reject(err)
        }
      })
  })
}

export const getCosUrlbykey = (objectKey: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    cos.headObject(
      {
        Key: objectKey,
        Bucket: bucket,
        Region: region
      },
      function (err) {
        if (err) {
          return reject(err)
        }

        cos.getObjectUrl(
          {
            Key: objectKey,
            Bucket: bucket,
            Region: region,
            Sign: false
          },
          function (innerErr, data) {
            if (innerErr) {
              return reject(innerErr)
            }

            if (data?.Url) {
              const url = data.Url.replace(/http:/, 'https:')
              return resolve(url)
            }
            return reject()
          }
        )
      }
    )
  })
}
